import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { isAnimatedPicture } from "../imageUploadService";
import { useUserQuery } from "../User/UserService.hooks";
import { CoreModal } from "../../components/modals/limit-modals/core-modal/CoreModal";
import { TransElement } from "../../data/constants";
import image from "../../components/modals/limit-modals/images/animated-limit-img.png";

interface FileUploaderProps {
    allowedFileTypes: readonly string[];
    onSuccess: (file: File) => void;
    disabled?: boolean;
    fileUploadLoading: boolean;
}

const FileUploadButton: React.FC<FileUploaderProps> = ({allowedFileTypes, onSuccess, disabled, fileUploadLoading}) => {
    const { t } = useTranslation()
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const { data: userData} = useUserQuery()
    const isActivePremium = userData?.user?.activePremium || userData?.user?.admin
    const [pendingFile, setPendingFile] = useState<File | null>(null);

    const handleButtonClick = () => {
        if (disabled) return;
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;
        event.target.value = '';

        const isAnimated = await isAnimatedPicture(file)

        if (isAnimated && !isActivePremium) {
            setPendingFile(file);
            return;
        }

        if ((file && allowedFileTypes.map(el => file.type.includes(el.toLowerCase().slice(1)))) || (allowedFileTypes.length === 1 && allowedFileTypes[0] === '*')) {
            onSuccess(file);
        } else {
            alert('File type not allowed');
        }
    };

    return <>
        <CoreModal
            show={!!pendingFile}
            onCancel={() => setPendingFile(null)}
            onSkip={() => { onSuccess(pendingFile!); setPendingFile(null); }}
            image={{ src: image, width: 212, height: 164 }}
            title={t("settings.animateModalTitle")}
            skipText={t("settings.Continue with image")}
            text={{
                innerText: (
                    <TransElement
                        i18nKey="settings.animateModalText"
                        components={{ br: <br /> }}
                    />
                ),
                className: "col-12 col-md-11",
            }}
        />
        <div
            className={`btn btn-primary text-white w-100 fw-bold p-2 py-md-3 overflow-ellipsis text-nowrap overflow-hidden px-md-3 ${disabled ? ' disabled' : ''}`}
            onClick={handleButtonClick}
            aria-disabled={disabled}
        >
            {!fileUploadLoading && <i className="bi bi-download"></i>} {!fileUploadLoading && t("settings.Upload New File")}
            {fileUploadLoading && (
                <div className="spinner-border ms-2" style={{width: "14px", height: "14px", borderWidth: "1px"}} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>)}
        </div>
        <input
            type="file"
            className='d-none'
            ref={fileInputRef}
            onChange={handleFileChange}
            accept={allowedFileTypes.join(',')}
            disabled={disabled}/>
    </>
}
export default FileUploadButton;
